import {Link} from '@primer/react'
import {memo} from 'react'

import type {WebSearchReferenceItem} from './web-search-utils'
import styles from './WebSearchReferences.module.css'

const WebSearchReferenceCard = memo(({reference}: {reference: WebSearchReferenceItem}) => {
  return (
    <li className={styles.Item}>
      <Link className={styles.Title} href={reference.url} rel="nofollow" inline>
        {reference.title}
      </Link>
      {reference.excerpt ? <div className={styles.Excerpt}>{reference.excerpt}</div> : null}
      <div className={styles.Url}>{reference.url}</div>
    </li>
  )
})
WebSearchReferenceCard.displayName = 'WebSearchReferenceCard'

/**
 * Renders web-search references (title + URL, optional excerpt) as a compact,
 * clickable list. Shown in place of the raw JSON tool output when a
 * `web_search` tool result yields parseable references.
 */
export function WebSearchReferences({references}: {references: WebSearchReferenceItem[]}) {
  return (
    <ul className={styles.List}>
      {references.map(reference => (
        <WebSearchReferenceCard key={reference.url} reference={reference} />
      ))}
    </ul>
  )
}
